import mutationsTypes from '@/store/mutationTypes'

const Mutations = {
  [mutationsTypes.LOADING_SET_LOADING_LIST]: (state, payload) => {
    state.loadingList = payload.loadingList
  },
  [mutationsTypes.LOADING_CANCEL_FLG]: (state, flag) => {
    state.cancelCompleted = flag
  }
}

export default Mutations
